<template>
    <div class="modal is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("note-type-selector.title") }}
                </p>
                <button class="delete" @click="close">></button>
            </header>
            <section class="modal-card-body">
                <div class="columns is-centered is-vcentered">
                    <div class="column is-narrow">
                        <div class="file is-boxed">
                            <label class="file-label">
                                <button
                                    class="file-input"
                                    @click="openCreatePlainTextNote"
                                ></button>
                                <span class="file-cta">
                                    <Icon
                                        family="fal"
                                        name="fa-sticky-note fa-2x"
                                    />
                                    <span class="file-label mt-1">
                                        {{
                                            $t("note-type-selector.plain-text")
                                        }}
                                    </span>
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="column is-narrow">
                        <div class="file is-boxed">
                            <label class="file-label">
                                <button
                                    class="file-input"
                                    @click="openCreateSoapNote"
                                ></button>
                                <span class="file-cta">
                                    <Icon
                                        family="fas"
                                        name="fa-file-medical fa-2x"
                                    />
                                    <span class="file-label mt-1">
                                        {{ $t("note-type-selector.soap") }}
                                    </span>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" @click="close">
                    {{ $t("note-type-selector.close") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { noteTypes } from "@/config/index.js";

export default {
    name: "note-type-selector-modal",
    methods: {
        close() {
            this.$emit("close");
        },
        openCreateNote(type) {
            this.$emit("selected", type);
        },
        openCreatePlainTextNote() {
            this.openCreateNote(noteTypes.plainText);
        },
        openCreateSoapNote() {
            this.openCreateNote(noteTypes.soap);
        },
    },
};
</script>